let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iho8v")).then(() => parcelRequire('4lHRm'));